module.exports = __webpack_public_path__ + "img/discord.b7f7a38f.svg";